export const LIBRARY_DIALOGS = [
  'login',
  'buy-loons',
  'rapid-reload',
  'loon-history',
  'connections',
  'chat-commands',
  'blocked-users',
  'blocked-twitch-terms',
  'custom-words',
] as const;

export type LibraryDialog = (typeof LIBRARY_DIALOGS)[number];

export const LIBRARY_PANELS = [
  'content-style',
  'player-access',
  'censorship',
  'poppy-chat',
  'volume-controls',
] as const;

export type LibraryPanel = (typeof LIBRARY_PANELS)[number];

export const LIBRARY_LOGIN_STEPS = ['choice', 'email'] as const;

export type LibraryLoginStep = (typeof LIBRARY_LOGIN_STEPS)[number];

export type LibraryRouteFacetState = Record<never, never[]>;

export type LibraryRouteEnumState = {
  dialog: LibraryDialog | null;
  section: LibraryPanel | null;
  loginStep: LibraryLoginStep;
};

export const LIBRARY_QUERY_CONFIG = {
  facets: {},
  enums: {
    dialog: {
      key: 'dialog',
      values: LIBRARY_DIALOGS,
      optional: true,
    },
    section: {
      key: 'section',
      values: LIBRARY_PANELS,
      optional: true,
      parse: (raw: string): LibraryPanel | undefined => {
        if (raw === 'moderation') {
          return 'player-access';
        }

        return (LIBRARY_PANELS as readonly string[]).includes(raw)
          ? (raw as LibraryPanel)
          : undefined;
      },
    },
    loginStep: {
      key: 'step',
      values: LIBRARY_LOGIN_STEPS,
      default: 'choice',
    },
  },
} as const;
